import React from 'react'
import { ReactComponent as IconLoading } from '../../assets/img/icon/loading.svg';

const LoadingComponent = () => {
  return (
    <div className="loading"><IconLoading /></div>
  )
}

export default LoadingComponent